'use client';

import React from 'react';

import { AuthLayout } from '@layouts/auth';
import GuestGuard from 'src/auth/guard/GuestGuard';

interface LayoutProps {
    children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => (
    <GuestGuard>
        <AuthLayout>{children}</AuthLayout>
    </GuestGuard>
);

export default Layout;
